import React from "react";

export default function MotivosNaoEnvio({ motivos }) {
  const total = (motivos || []).reduce((s, m) => s + m.total, 0);
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5" data-e2e="motivos-recuperador">
      <h3 className="font-semibold">Quando a CLEO não mandou</h3>
      <p className="text-xs text-muted-foreground mb-4">Conversas em que a mensagem não fazia sentido — e por quê.</p>
      {total === 0 ? (
        <p className="text-sm text-muted-foreground py-4 text-center">Nada no período.</p>
      ) : (
        <ul className="space-y-2">
          {motivos.map((m) => (
            <li key={m.motivo} className="flex items-center gap-3 text-sm">
              <span className="w-44 shrink-0 truncate">{m.rotulo}</span>
              <span className="flex-1 h-2 rounded-full bg-muted overflow-hidden">
                <span className="block h-full rounded-full bg-muted-foreground/50" style={{ width: `${(m.total * 100) / total}%` }} />
              </span>
              <span className="w-10 text-right tabular-nums font-semibold">{m.total}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
